import React from "react";
import Input from "../../../../components/FormComponents/Input";
import { getLabelForKey } from "../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditPercentage = (props) => {
  const { editFieldData, setEditFieldData } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };

  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("default_value")}
        value={editFieldData.default_value}
        name="default_value"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="d_flex">
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("backend_validation")}
          checked={editFieldData.validate.backend_validation}
          name="backend_validation"
          size="medium"
          containerClassName="w_50"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          type="number"
          label={getLabelForKey("max_digit")}
          value={editFieldData.validate.max_digit}
          name="max_digit"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.value)}
          containerClassName="w_25"
        />
        <Input
          type="number"
          label={getLabelForKey("decimal_point")}
          value={editFieldData.validate.decimal_point}
          name="decimal_point"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.value)}
          containerClassName="w_25"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditPercentage;
